import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { Link } from "../../utils/customLink";

import TrustpilotLogo from "images/icons/trustpilot-logo.inline.svg";
import TrustpilotRating from "images/icons/trustpilot-stars.inline.svg";
import TrustpilotLogoLight from "images/icons/trustpilot-logo-light.inline.svg";
import TrustpilotRatingLight from "images/icons/trustpilot-rating-light.inline.svg";

const ProgramRating = ({
  outerContainerClass = "w-full items-end justify-end",
  ratingIconClass = "fill-generic-text h-5",
  ratingLogoClass = "fill-gray-lighter h-5",
  darkRatingIconClass = "hidden sm:block h-5 w-auto fill-white",
  darkRatingLogoClass = "w-auto h-5 fill-white",
  darkContainerClass = "flex gap-3"
}) => {
  const { colorMode } = useTheme();

  return (
    <>
      <div className={`program-rating flex ${outerContainerClass} `}>
        <Link
          to={"https://www.trustpilot.com/review/gvi.co.uk"}
          target={"gvi_blank"}
          className={`flex ${outerContainerClass} `}
        >
          {colorMode === "light" ? (
            <>
              <TrustpilotLogoLight
                className={`${ratingLogoClass} w-auto pr-3`}
              />
              <TrustpilotRatingLight className={`${ratingIconClass} w-auto`} />
            </>
          ) : (
            <>
              <div className={darkContainerClass}>
                <TrustpilotLogo className={darkRatingLogoClass} />
                <TrustpilotRating className={darkRatingIconClass} />
              </div>
            </>
          )}
        </Link>
      </div>
    </>
  );
};

export default ProgramRating;
